import type { PageBlockDefinition } from '../definition-types'

export const spacerDefinition: PageBlockDefinition = {
  type: 'spacer',
  label: 'Spacer',
  description: 'Transparent vertical gap. Controls breathing room between editorial rows.',
  category: 'structural',
  rowCompatible: true,
  columnCompatible: false,
  minArticles: 0,
  maxArticles: 0,
  slots: [],
  defaultConfig: {
    size: 'md',
  },
  editorFields: [
    {
      key: 'size',
      label: 'Size',
      type: 'select',
      options: [
        { label: 'Small (8px)',        value: 'sm' },
        { label: 'Medium (24px)',      value: 'md' },
        { label: 'Large (48px)',       value: 'lg' },
        { label: 'Extra Large (80px)', value: 'xl' },
      ],
    },
  ],
}
